import { render, staticRenderFns } from "./AcademicWorks.vue?vue&type=template&id=f2a304e0&scoped=true"
import script from "./AcademicWorks.vue?vue&type=script&lang=js"
export * from "./AcademicWorks.vue?vue&type=script&lang=js"
import style0 from "./AcademicWorks.vue?vue&type=style&index=0&id=f2a304e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2a304e0",
  null
  
)

export default component.exports